import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { BaseField } from './BaseField';
import type { BaseFieldProps } from './types';

/**
 * Signature field component
 * Only available in form-builder format
 * Note: This is a placeholder implementation. 
 * Full signature capture would require a canvas-based component.
 */
export const SignatureField: React.FC<BaseFieldProps> = ({
  field,
  value,
  onChange,
  onBlur,
  mode = 'edit',
  error,
  touched,
  sx,
  showLabel = true,
  disabled,
}) => {
  // Extract field properties
  const label = 'label' in field ? field.label : 'Signature';

  // Handle display mode
  if (mode === 'display') {
    return (
      <BaseField field={field} mode={mode} sx={sx} showLabel={showLabel}>
        <Typography variant="body2">
          {value ? 'Signed' : 'Not signed'}
        </Typography>
      </BaseField>
    );
  }

  // Handle edit/preview modes
  return (
    <BaseField
      field={field}
      mode={mode}
      error={error}
      touched={touched}
      sx={sx}
      showLabel={showLabel}
      disabled={disabled}
    >
      <Paper
        variant="outlined"
        sx={{
          p: 3,
          minHeight: 150,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: mode === 'preview' ? 'action.disabledBackground' : 'background.paper',
          cursor: mode === 'edit' && !disabled ? 'pointer' : 'default',
        }}
        onClick={() => {
          if (mode === 'edit' && !disabled && onChange) {
            // In a real implementation, this would open a signature capture modal
            onChange('signature-placeholder');
          }
        }}
        onBlur={onBlur}
      >
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ fontStyle: 'italic' }}
        >
          {value ? 'Signature captured' : 'Click to sign'}
        </Typography>
      </Paper>
    </BaseField>
  );
};